/**
 * @generated SignedSource<<e5a932507584148c7318fad8cc2050fb>>
 * @relayHash dbb4fc405135e8a7a440f4a278aa8a4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery } from './src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery.graphql';

const node: PreloadableConcreteRequest<src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51",
    "metadata": {},
    "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
